/**
 * Componente responsável por exibir informações do produto na vitrine (SDSN).
 *
 * @remarks
 * Este componente recebe um `ShopWindowItem` e exibe seus valores, incluindo valor base,
 * valor da parcela mensal e valor total. Também emite um evento quando o produto é clicado.
 *
 * @example
 * ```html
 * <pme-product-sdsn
 *   [shopWindowItem]="item"
 *   [periodicity]="periodicity"
 *   (clickOnProduct)="handleProductClick()">
 * </pme-product-sdsn>
 * ```
 *
 * @input shopWindowItem - O item de produto a ser exibido.
 * @input periodicity - A string de periodicidade (ex: "mensal").
 * @output clickOnProduct - Evento emitido quando o produto é clicado.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShopWindowItem } from '../../model/shop-window-item';
@Component({
    selector: 'pme-product-sdsn',
    templateUrl: './product-sdsn.component.html',
    styleUrls: ['./product-sdsn.component.scss'],
    standalone: false
})
export class ProductSdsnComponent {

  @Input() shopWindowItem: ShopWindowItem;
  @Input() periodicity: string;

  @Output() clickOnProduct = new EventEmitter<void>()

  constructor() { }

  getValue(type: string): string {
    switch (type) {
      case 'baseValue':
        return this.shopWindowItem.baseValue.toFixed(2).replace('.', ',');
      case 'monthlyValue':
        return this.shopWindowItem.paymentMethods.find(paymentMethod => paymentMethod.identifier === 'ADYEN')?.maxInstallmentValue.toFixed(2).replace('.', ',');
      case 'totalValue':
        return this.shopWindowItem.totalValue.toFixed(2).replace('.', ',');
      default:
        console.warn(`Unknown type: ${type}`);
        return '';
    }
  }

  isAppliedDiscounts(): boolean {
    return this.shopWindowItem.appliedDiscounts && this.shopWindowItem.appliedDiscounts.length > 0;
  }

  onClick(): void {
    this.clickOnProduct.emit();
  }

  getPeriodicityLabel(): string {
    switch (String(this.shopWindowItem.product.periodicity).toLowerCase()) {
      case 'mensal':
        return 'por mês';
      case 'anual':
        return 'por ano';
      case 'semestral':
        return 'por semestre';
      default:
        return '';
    }
  }
}
